/**
 * Copyright 2024 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { useRedirectAfterVehicleChanged } from '../../../hooks/useRedirectAfterVehicleChanged';
import { CMSYmme } from '@/features/contentstack/components/CMSYmme/CMSYmme';

export function CMSCategoryYMME() {
  const redirectAfterVehicleChanged = useRedirectAfterVehicleChanged();

  return (
    <CMSYmme
      content={{}}
      redirectAfterVehicleChanged={redirectAfterVehicleChanged}
      removeMargins
      withPadding={false}
      nonShopPage={true}
    />
  );
}
